/* Waymino v7 · lo que se mueve en la portada.
   Generado desde waymino-landing-v7.html el 12/08/2026. Sin la cabecera ni el
   menú: en la tienda los pone el tema. */

(function(){
'use strict';
var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
var raiz = document.querySelector('.wm7') || document;
var $ = function(s,c){ return (c||raiz).querySelector(s); };
var $$ = function(s,c){ return [].slice.call((c||raiz).querySelectorAll(s)); };

/* ---------- CONFIGURACIÓN EDITABLE ---------- */
/* El número de reservas viene del ajuste de la sección (data-reservadas), no
   de aquí: así lo cambias en el editor de temas según entren de verdad. */
var WM = { total:200, reservadas:0 };
/* 05/10/2026 · INGLÉS: la tienda en /en pinta <html lang="en">. T(es, en)
   devuelve el texto en el idioma de la página. Si añades un texto, pásalo por T. */
var WM_EN = /^en/i.test(document.documentElement.lang || '');
function T(es, en){ return WM_EN ? en : es; }
(function(){
  var rej = document.querySelector('#nums');
  var n = rej && parseInt(rej.getAttribute('data-reservadas'), 10);
  if(!isNaN(n) && n >= 0) WM.reservadas = Math.min(n, WM.total);
})();

/* ---------- progreso + cabecera ---------- */
/* En la tienda, la cabecera y el menú son los del tema: aquí solo queda la
   barra de progreso. Con guardas: un elemento que falte no puede tumbar la página. */
var bar = $('#prog'), raf = null;
function onScroll(){
  var h = document.documentElement;
  if(bar) bar.style.transform = 'scaleX(' + (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight)) + ')';
  raf = null;
}
addEventListener('scroll', function(){ if(!raf) raf = requestAnimationFrame(onScroll); }, {passive:true});
onScroll();

/* ---------- aparecer ---------- */
var io = new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
}, {rootMargin:'0px 0px -12% 0px', threshold:.1});
$$('[data-rev]').forEach(function(el){ REDUCE ? el.classList.add('in') : io.observe(el); });
/* Red de seguridad: si el navegador no dispara el observador (pestaña en
   segundo plano, navegador raro, JS a medias), a los 2,5 s se enseña todo.
   Sin esto, un fallo del observador deja la página EN BLANCO — visto al
   probarla dentro de un iframe. Una tienda no se puede permitir eso. */
setTimeout(function(){ $$('[data-rev]').forEach(function(el){ el.classList.add('in'); }); }, 2500);

/* ---------- titular palabra a palabra ---------- */
(function(){
  var h1 = $('#h1'); if(!h1) return;
  $$('.w i', h1).forEach(function(i,k){ i.style.transitionDelay = (0.1 + k*0.055) + 's'; });
  requestAnimationFrame(function(){ h1.classList.add('go'); });
  setTimeout(function(){ h1.classList.add('go'); }, 1200);
})();

/* ---------- la pulsera en 3D ---------- */
function pulsera3d(stageSel, shineSel){
  var stage = $(stageSel), shine = $(shineSel);
  if(!stage) return;
  var wrap = stage.parentElement;
  var rx = -6, ry = 0, tx = 0, cur = {rx:-6, ry:0}, arrastrando = false, x0 = 0, ry0 = 0;
  function pintar(){
    cur.rx += (rx - cur.rx) * .12;
    cur.ry += (ry - cur.ry) * .12;
    stage.style.transform = 'rotateX(' + cur.rx.toFixed(2) + 'deg) rotateY(' + cur.ry.toFixed(2) + 'deg)';
    if(shine) shine.style.transform = 'translateX(' + (-60 + (cur.ry + 22) / 44 * 120).toFixed(1) + '%)';
    requestAnimationFrame(pintar);
  }
  if(!REDUCE) requestAnimationFrame(pintar);
  wrap.addEventListener('pointermove', function(e){
    if(arrastrando) return;
    var r = wrap.getBoundingClientRect();
    ry = ((e.clientX - r.left) / r.width - .5) * 30;
    rx = -6 - ((e.clientY - r.top) / r.height - .5) * 14;
  });
  wrap.addEventListener('pointerleave', function(){ if(!arrastrando){ rx = -6; ry = 0; } });
  stage.addEventListener('pointerdown', function(e){
    arrastrando = true; x0 = e.clientX; ry0 = ry;
    stage.setPointerCapture(e.pointerId);
    wrap.classList.add('moved');
  });
  stage.addEventListener('pointermove', function(e){
    if(!arrastrando) return;
    ry = Math.max(-26, Math.min(26, ry0 + (e.clientX - x0) * .22));
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    stage.addEventListener(ev, function(){ arrastrando = false; });
  });
}
/* En la portada ya no hay tarjeta: la pulsera gira de verdad (más abajo).
   pulsera3d() se queda para el bloque de la mitad de la página. */
pulsera3d('#p3dStage2','#p3dShine2');

/* ---------- la pulsera girando (portada) ----------
   36 fotogramas en una hoja de 6×6. Se avanza con `transform`, NO con
   background-position: aquello obligaba al navegador a repintar el elemento
   entero en cada fotograma reescalando una imagen de 2400 px, y en un móvil
   daba tirones. Con transform el trabajo lo hace la GPU componiendo una capa ya
   pintada. Da igual un iPhone nuevo que un Android de hace cinco años.
   Gira sola a ~9 fotogramas por segundo (4 s la vuelta) porque más rápido
   parece un GIF de anuncio y más lento parece que se ha colgado.
   Al arrastrarla la manda el dedo, y tras soltarla espera 900 ms antes de
   seguir sola: si arranca de golpe, parece que te ha quitado el control. */
(function(){
  var caja = $('#giro'), capa = $('#giroF');
  if(!caja || !capa) return;
  var N = 36, COL = 6, PASO = 100 / COL;   /* 16,6667 % del tamaño de la capa */
  var f = 0, arrastrando = false, x0 = 0, f0 = 0, quieta = 0, ultimo = 0;

  function pinta(){
    var i = ((Math.round(f) % N) + N) % N;
    capa.style.transform = 'translate3d(' + (-(i % COL) * PASO) + '%,' +
                          (-Math.floor(i / COL) * PASO) + '%,0)';
  }

  /* La hoja la pone Liquid en --hoja para no escribir aquí la URL del CDN.
     Se precarga con un Image() y solo se enseña cuando está entera: si no,
     lo primero que ve el visitante es media pulsera a medio descargar. */
  var hoja = getComputedStyle(caja).getPropertyValue('--hoja').trim()
               .replace(/^url\(\s*["']?/, '').replace(/["']?\s*\)$/, '');
  var img = new Image();
  img.onload = function(){ caja.classList.add('lista'); pinta(); };
  img.onerror = function(){ caja.classList.add('lista'); };   /* nunca dejarla invisible */
  if(hoja) img.src = hoja; else caja.classList.add('lista');

  var envoltorio = caja.closest ? caja.closest('.p3d') : null;
  caja.addEventListener('pointerdown', function(e){
    arrastrando = true; x0 = e.clientX; f0 = f;
    if(envoltorio) envoltorio.classList.add('moved');
    caja.setPointerCapture(e.pointerId);
  });
  caja.addEventListener('pointermove', function(e){
    if(!arrastrando) return;
    /* una vuelta entera cada ~340 px de arrastre: ni pesada ni nerviosa */
    f = f0 - (e.clientX - x0) * (N / 340);
    pinta();
  });
  ['pointerup','pointercancel'].forEach(function(ev){
    caja.addEventListener(ev, function(){ arrastrando = false; quieta = performance.now(); });
  });

  /* VAIVÉN, NO VUELTA ENTERA.
     Dando la vuelta completa hay medio giro en el que se ve la trasera: en un
     bucle de 4 s el sello desaparece unos 2. En una portada eso es la mitad del
     tiempo sin marca. Así que sola oscila ±6 fotogramas (±60°) alrededor del
     frente, con el seno haciendo el frenado en las puntas — nunca pierde el
     sello. La vuelta entera sigue estando: se llega arrastrando, que es donde
     el que quiere ver el cierre va a mirar. */
  var AMPL = 6, PERIODO = 54;                    // 54 pasos × 110 ms ≈ 6 s de ida y vuelta
  var fase = 0;

  (function bucle(t){
    requestAnimationFrame(bucle);
    if(REDUCE || arrastrando) return;
    if(quieta && t - quieta < 900) return;
    if(t - ultimo < 110) return;
    ultimo = t;
    fase += 1;
    var objetivo = AMPL * Math.sin(fase * 2 * Math.PI / PERIODO);
    /* Tras arrastrar, la pulsera puede haber quedado del revés. Se vuelve al
       vaivén por el camino corto y con suavizado, no de un salto. */
    var d = objetivo - f;
    d = ((d + N/2) % N + N) % N - N/2;
    f += d * 0.18;
    pinta();
  })(0);
})();

/* ---------- escasez y rejilla de 200 ----------
   Los reservados se pintan DESDE EL Nº 1 HACIA ARRIBA, no salpicados por la
   rejilla. Es la única forma coherente con lo que promete el texto de al lado:
   "los números se asignan por orden de reserva". Si se pintasen sueltos, un
   comprador que mire dos segundos ve que el nº 1 sigue libre y el 137 cogido,
   y la promesa se cae sola.
   `WM.reservadas` es el número REAL de reservas. En la tienda lo gobierna el
   ajuste "Cuántas van reservadas" de la sección, sin tocar código. */
(function(){
  var t = $('#ticks'), n = $('#nums'), txt = $('#scarTxt');
  if(!t || !txt) return; /* 05/10/2026: la barra y la rejilla se quitaron de la portada */
  var f1 = document.createDocumentFragment(), f2 = document.createDocumentFragment();
  /* Números con historia: dan relieve a la rejilla sin fingir ventas. */
  var HITOS = WM_EN ? { 1:'The first', 100:'Halfway', 200:'The last' } : { 1:'El primero', 100:'La mitad', 200:'El último' };
  for(var i=1;i<=WM.total;i++){
    var a = document.createElement('i');
    if(i <= WM.reservadas) a.className = 'on'; else if(i===1) a.className = 'one';
    f1.appendChild(a);
    var b = document.createElement('i');
    b.dataset.n = T('Nº ','No. ') + String(i).padStart(3,'0') + (HITOS[i] ? ' · ' + HITOS[i] : '');
    if(i <= WM.reservadas) b.className = 'taken';
    else if(HITOS[i]) b.className = i === 1 ? 'one hito' : 'hito';
    f2.appendChild(b);
  }
  t.appendChild(f1); if(n) n.appendChild(f2);
  txt.innerHTML = WM.reservadas === 0
    ? T('<b>Los ' + WM.total + ' números están libres.</b> Incluido el nº 1.',
        '<b>All ' + WM.total + ' numbers are available.</b> Including no. 1.')
    : T('<b>Quedan ' + (WM.total - WM.reservadas) + ' de ' + WM.total + '</b> números de fundador.',
        '<b>' + (WM.total - WM.reservadas) + ' of ' + WM.total + ' left</b> founder numbers.');
})();

/* ---------- ELIGE TU CAMINO ---------- */
(function(){
  var RUTAS = [
    { id:'portugues', nombre:'Camino Portugués', corto:'Portugués',
      desde:'Desde Lisboa · el que cruza O Porriño cada mañana',
      cuando:'Mejor época: primavera y septiembre', km:620, dias:26,
      hitos:['Lisboa','Santarém','Tomar','Coimbra','Porto','Barcelos','Ponte de Lima','Tui','O Porriño','Redondela','Pontevedra','Caldas de Reis','Padrón','Santiago'],
      etapas:25,
      pueblos:['Lisboa','Vila Franca de Xira','Azambuja','Santarém','Golegã','Tomar','Alvaiázere','Alvorge','Cernache','Coimbra','Sernadelo','Águeda','Albergaria-a-Velha','São João da Madeira','Grijó','Porto','Vilarinho','Barcelos','Ponte de Lima','Rubiães','Tui','Redondela','Pontevedra','Caldas de Reis','Padrón','Santiago'] },
    { id:'frances', nombre:'Camino Francés', corto:'Francés',
      desde:'Desde Saint-Jean-Pied-de-Port · el más caminado',
      cuando:'Mejor época: mayo, junio y septiembre', km:772, dias:33,
      hitos:['Saint-Jean','Pamplona','Logroño','Burgos','León','Astorga','Sarria','Santiago'],
      etapas:33,
      pueblos:['Saint-Jean-Pied-de-Port','Roncesvalles','Zubiri','Pamplona','Puente la Reina','Estella','Los Arcos','Logroño','Nájera','Santo Domingo de la Calzada','Belorado','San Juan de Ortega','Burgos','Hornillos del Camino','Castrojeriz','Frómista','Carrión de los Condes','Terradillos de los Templarios','Bercianos del Real Camino','Mansilla de las Mulas','León','Villar de Mazarife','Astorga','Foncebadón','Ponferrada','Villafranca del Bierzo','O Cebreiro','Triacastela','Sarria','Portomarín','Palas de Rei','Arzúa','O Pedrouzo','Santiago'] },
    { id:'costa', nombre:'Portugués de la Costa', corto:'Portugués Costa',
      desde:'Desde Porto, pegado al Atlántico',
      cuando:'Mejor época: de mayo a octubre', km:269, dias:12,
      hitos:['Porto','Vila do Conde','Viana do Castelo','Caminha','A Guarda','Baiona','Vigo','Redondela','Pontevedra','Caldas de Reis','Padrón','Santiago'],
      etapas:13,
      pueblos:['Porto','Labruge','Póvoa de Varzim','Marinhas','Viana do Castelo','Caminha','Porto Mougás','A Ramallosa','Vigo','Redondela','Pontevedra','Caldas de Reis','Padrón','Santiago'] },
    { id:'norte', nombre:'Camino del Norte', corto:'Norte',
      desde:'Desde Irún, por la cornisa cantábrica',
      cuando:'Mejor época: junio a septiembre', km:825, dias:34,
      hitos:['Irún','Bilbao','Santander','Gijón','Ribadeo','Mondoñedo','Arzúa','Santiago'],
      etapas:36,
      pueblos:['Irún','San Sebastián','Zarautz','Deba','Markina-Xemein','Gernika','Lezama','Bilbao','Portugalete','Castro Urdiales','Laredo','Güemes','Santander','Santillana del Mar','Comillas','Colombres','Llanes','Ribadesella','Colunga','Villaviciosa','Gijón','Avilés','Muros de Nalón','Soto de Luiña','Cadavedo','Luarca','La Caridad','Ribadeo','Gondán','Mondoñedo','Abadín','Vilalba','Baamonde','Sobrado dos Monxes','Arzúa','O Pedrouzo','Santiago'] },
    { id:'ingles', nombre:'Camino Inglés', corto:'Inglés',
      desde:'Desde Ferrol · el más corto que da la Compostela',
      cuando:'Mejor época: todo el año', km:122, dias:6,
      hitos:['Ferrol','Pontedeume','Betanzos','Bruma','Sigüeiro','Santiago'],
      etapas:5,
      pueblos:['Ferrol','Pontedeume','Betanzos','Hospital de Bruma','Sigüeiro','Santiago'] },
    { id:'primitivo', nombre:'Camino Primitivo', corto:'Primitivo',
      desde:'Desde Oviedo · el primero de todos',
      cuando:'Mejor época: de mayo a septiembre', km:313, dias:14,
      hitos:['Oviedo','Salas','Tineo','Pola de Allande','Grandas de Salime','A Fonsagrada','Lugo','Melide','Santiago'],
      etapas:14,
      pueblos:['Oviedo','Grado','Salas','Tineo','Campiello','Pola de Allande','La Mesa','Grandas de Salime','A Fonsagrada','O Cádavo Baleira','Lugo','San Román da Retorta','Melide','Arzúa','O Pedrouzo','Santiago'] },
    { id:'plata', nombre:'Vía de la Plata', corto:'Vía de la Plata',
      desde:'Desde Sevilla · el más largo de todos',
      cuando:'Mejor época: primavera y otoño. En verano, inviable', km:970, dias:37,
      hitos:['Sevilla','Zafra','Mérida','Cáceres','Salamanca','Zamora','Granja de Moreruela','Puebla de Sanabria','Ourense','Santiago'],
      etapas:37,
      pueblos:['Sevilla','Guillena','Castilblanco de los Arroyos','Almadén de la Plata','Monesterio','Fuente de Cantos','Zafra','Villafranca de los Barros','Torremejía','Mérida','Alcuéscar','Cáceres','Embalse de Alcántara','Grimaldo','Carcaboso','Aldeanueva del Camino','La Calzada de Béjar','Fuenterroble de Salvatierra','San Pedro de Rozados','Salamanca','El Cubo del Vino','Zamora','Montamarta','Granja de Moreruela','Tábara','Santa Marta de Tera','Mombuey','Puebla de Sanabria','Lubián','A Gudiña','Laza','Xunqueira de Ambía','Ourense','Cea','O Castro','Silleda','Outeiro','Santiago'] },
    { id:'sanabres', nombre:'Camino Sanabrés', corto:'Sanabrés',
      desde:'Desde Granja de Moreruela · el desvío gallego de la Plata',
      cuando:'Mejor época: primavera y otoño', km:362, dias:14,
      hitos:['Granja de Moreruela','Tábara','Puebla de Sanabria','A Gudiña','Laza','Ourense','Cea','Silleda','Santiago'],
      etapas:14,
      pueblos:['Granja de Moreruela','Tábara','Santa Marta de Tera','Mombuey','Puebla de Sanabria','Lubián','A Gudiña','Laza','Xunqueira de Ambía','Ourense','Cea','O Castro','Silleda','Outeiro','Santiago'] },
    { id:'invierno', nombre:'Camino de Invierno', corto:'Invierno',
      desde:'Desde Ponferrada · el que evitaba la nieve de O Cebreiro',
      cuando:'Mejor época: todo el año. Para eso se inventó', km:266, dias:12,
      hitos:['Ponferrada','Las Médulas','O Barco de Valdeorras','Quiroga','Monforte de Lemos','Chantada','Lalín','Silleda','Santiago'],
      etapas:12,
      pueblos:['Ponferrada','Las Médulas','O Barco de Valdeorras','A Rúa de Valdeorras','Quiroga','A Pobra do Brollón','Monforte de Lemos','Chantada','Rodeiro','Lalín','Silleda','Outeiro','Santiago'] },
    { id:'fisterra', nombre:'Fisterra e Muxía', corto:'Fisterra',
      desde:'Desde Santiago · el único que empieza donde los demás acaban',
      cuando:'Mejor época: de mayo a octubre', km:113, dias:4,
      hitos:['Santiago','Negreira','Olveiroa','Muxía','Fisterra'],
      etapas:4,
      pueblos:['Santiago','Negreira','Olveiroa','Muxía','Fisterra','Faro de Finisterre'] }
  ];
  if (WM_EN) {
    var RUTAS_EN = {
      portugues:{ nombre:'Portuguese Way', corto:'Portuguese', desde:'From Lisbon · the one that crosses O Porriño every morning', cuando:'Best time: spring and September' },
      frances:{ nombre:'French Way', corto:'French', desde:'From Saint-Jean-Pied-de-Port · the most walked', cuando:'Best time: May, June and September' },
      costa:{ nombre:'Portuguese Coastal Way', corto:'Portuguese Coastal', desde:'From Porto, along the Atlantic', cuando:'Best time: May to October' },
      norte:{ nombre:'Northern Way', corto:'Northern', desde:'From Irún, along the Cantabrian coast', cuando:'Best time: June to September' },
      ingles:{ nombre:'English Way', corto:'English', desde:'From Ferrol · the shortest that earns the Compostela', cuando:'Best time: all year round' },
      primitivo:{ nombre:'Primitive Way', corto:'Primitive', desde:'From Oviedo · the very first one', cuando:'Best time: May to September' },
      plata:{ nombre:'Vía de la Plata', corto:'Vía de la Plata', desde:'From Seville · the longest of all', cuando:'Best time: spring and autumn. In summer, not doable' },
      sanabres:{ nombre:'Sanabrés Way', corto:'Sanabrés', desde:'From Granja de Moreruela · the Galician branch of the Plata', cuando:'Best time: spring and autumn' },
      invierno:{ nombre:'Winter Way', corto:'Winter', desde:'From Ponferrada · the one that avoided the snow at O Cebreiro', cuando:'Best time: all year round. That is what it was made for' },
      fisterra:{ nombre:'Fisterra and Muxía', corto:'Fisterra', desde:'From Santiago · the only one that starts where the others end', cuando:'Best time: May to October' }
    };
    RUTAS.forEach(function(r){ var e = RUTAS_EN[r.id]; if (e) for (var k in e) r[k] = e[k]; });
  }
  /* Geometría REAL de los cinco Caminos, sacada de las coordenadas que ya usa
     el generador del vídeo (lib/video/caminos.ts) y proyectada en un único
     encuadre común. Antes los cinco se dibujaban con la MISMA curva inventada
     y solo cambiaban los nombres: cualquiera que conozca el Camino lo cazaba. */
  var GEO = {"meta":{"W":1000,"H":940,"kmU":0.822,"sx":168.1,"sy":177.4},"rutas":{"frances":{"d":"M890.7 140.2C889.3 143.6,886.9 155.4,882.5 160.5C878.1 165.6,869.7 166.4,864.3 170.7C858.9 175.0,855.3 180.6,850.2 186.3C845.1 192.0,839.9 201.7,833.6 204.8C827.3 207.9,818.5 202.6,812.3 204.8C806.1 207.0,803.1 213.7,796.3 218.2C789.4 222.7,780.1 228.6,771.2 231.9C762.3 235.3,751.1 237.8,742.7 238.3C734.3 238.8,728.5 235.2,721.0 235.1C713.5 235.0,705.5 236.4,697.5 237.8C689.5 239.2,681.5 242.0,673.1 243.7C664.8 245.4,659.0 245.9,647.4 247.8C635.8 249.7,615.5 253.3,603.8 255.0C592.1 256.7,585.0 259.0,577.3 257.9C569.6 256.8,568.1 250.9,557.8 248.6C547.5 246.3,529.1 247.8,515.7 244.3C502.3 240.8,486.2 232.5,477.3 227.5C468.4 222.5,470.1 213.6,462.5 214.4C454.9 215.2,439.4 229.1,431.4 232.2C423.4 235.3,421.1 233.1,414.5 232.7C407.9 232.3,400.6 231.6,391.7 229.7C382.8 227.8,369.9 224.0,361.2 221.3C352.5 218.6,347.0 216.8,339.6 213.3C332.2 209.8,323.7 203.4,316.6 200.1C309.5 196.8,303.3 195.3,297.2 193.7C291.1 192.1,286.1 191.5,279.9 190.4C273.7 189.3,267.4 189.0,259.9 187.0C252.4 185.0,241.6 180.7,235.0 178.3C228.4 176.0,225.4 174.1,220.6 172.9C215.8 171.7,211.8 170.8,206.0 171.0C200.2 171.2,192.2 172.7,185.9 173.8C179.6 174.9,171.1 176.8,168.1 177.4","g":[{"n":"Saint-Jean","x":890.7,"y":140.2,"t":0},{"n":"Pamplona","x":850.2,"y":186.3,"t":0.094},{"n":"Logroño","x":771.2,"y":231.9,"t":0.219},{"n":"Burgos","x":647.4,"y":247.8,"t":0.375},{"n":"León","x":462.5,"y":214.4,"t":0.563},{"n":"Astorga","x":414.5,"y":232.7,"t":0.625},{"n":"Sarria","x":279.9,"y":190.4,"t":0.813},{"n":"Santiago","x":168.1,"y":177.4,"t":1}],"m":[{"n":"Saint-Jean","x":890.7,"y":140.2,"t":0,"i":0},{"n":"Logroño","x":771.2,"y":231.9,"t":0.219,"i":2},{"n":"Astorga","x":414.5,"y":232.7,"t":0.625,"i":5},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":7}],"lista":["Saint-Jean","Pamplona","Logroño","Burgos","León","Astorga","Sarria","Santiago"],"bb":[168.1,140.2,890.7,257.9]},"portugues":{"d":"M109.3 724.6C116.8 713.3,142.1 676.3,154.1 657.0C166.1 637.7,176.8 629.8,181.4 608.6C186.0 587.4,182.0 551.0,181.4 529.7C180.8 508.4,179.0 491.5,177.9 480.8C176.8 470.1,175.6 472.8,174.7 465.7C173.8 458.6,175.0 448.3,172.5 438.0C170.0 427.7,161.6 418.1,159.7 404.1C157.8 390.1,160.3 367.4,161.1 354.0C161.9 340.6,164.3 332.4,164.3 323.8C164.3 315.2,162.0 308.2,161.0 302.1C160.0 296.0,158.4 292.1,158.3 287.1C158.2 282.1,160.1 277.3,160.7 272.1C161.3 266.9,162.1 261.9,161.7 256.0C161.3 250.1,158.8 243.7,158.2 236.6C157.6 229.5,158.7 220.5,158.4 213.7C158.1 206.9,155.0 202.1,156.6 196.0C158.2 189.9,166.2 180.5,168.1 177.4","g":[{"n":"Lisboa","x":109.3,"y":724.6,"t":0.0,"rol":"inicio","casa":false},{"n":"Santarém","x":154.1,"y":657.0,"t":0.059,"rol":"paso","casa":false},{"n":"Tomar","x":181.4,"y":608.6,"t":0.118,"rol":"paso","casa":false},{"n":"Coimbra","x":181.4,"y":529.7,"t":0.176,"rol":"paso","casa":false},{"n":"Porto","x":159.7,"y":404.1,"t":0.412,"rol":"paso","casa":false},{"n":"Barcelos","x":161.1,"y":354.0,"t":0.471,"rol":"paso","casa":false},{"n":"Ponte de Lima","x":164.3,"y":323.8,"t":0.529,"rol":"paso","casa":false},{"n":"Tui","x":158.3,"y":287.1,"t":0.647,"rol":"paso","casa":true},{"n":"O Porriño","x":160.7,"y":272.1,"t":0.706,"rol":"paso","casa":true},{"n":"Redondela","x":161.7,"y":256.0,"t":0.765,"rol":"paso","casa":true},{"n":"Pontevedra","x":158.2,"y":236.6,"t":0.824,"rol":"paso","casa":true},{"n":"Caldas de Reis","x":158.4,"y":213.7,"t":0.882,"rol":"paso","casa":true},{"n":"Padrón","x":156.6,"y":196.0,"t":0.941,"rol":"paso","casa":true},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false}],"m":[{"n":"Lisboa","x":109.3,"y":724.6,"t":0.0,"rol":"inicio","casa":false,"i":0},{"n":"Porto","x":159.7,"y":404.1,"t":0.412,"rol":"paso","casa":false,"i":4},{"n":"Redondela","x":161.7,"y":256.0,"t":0.765,"rol":"paso","casa":true,"i":9},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false,"i":13}],"lista":["Lisboa","Santarém","Tomar","Coimbra","Porto","Barcelos","Ponte de Lima","Tui","O Porriño","Redondela","Pontevedra","Caldas de Reis","Padrón","Santiago"],"bb":[109.3,177.4,181.4,724.6]},"costa":{"d":"M159.7 404.1C157.8 399.9,151.0 386.8,148.5 378.6C146.0 370.4,146.0 362.2,144.5 354.7C143.0 347.2,140.3 341.2,139.4 333.8C138.5 326.4,139.7 314.7,139.0 310.1C138.3 305.5,135.9 308.9,135.4 306.1C134.9 303.3,135.5 298.1,135.9 293.3C136.3 288.5,135.3 282.8,137.8 277.5C140.3 272.2,146.7 265.2,150.7 261.6C154.7 258.0,160.4 260.2,161.7 256.0C162.9 251.8,158.8 243.7,158.2 236.6C157.6 229.5,158.7 220.5,158.4 213.7C158.1 206.9,155.0 202.1,156.6 196.0C158.2 189.9,166.2 180.5,168.1 177.4","g":[{"n":"Porto","x":159.7,"y":404.1,"t":0.0,"rol":"inicio","casa":false},{"n":"Vila do Conde","x":148.5,"y":378.6,"t":0.077,"rol":"paso","casa":false},{"n":"Viana do Castelo","x":139.4,"y":333.8,"t":0.231,"rol":"paso","casa":false},{"n":"Caminha","x":139.0,"y":310.1,"t":0.308,"rol":"paso","casa":false},{"n":"A Guarda","x":135.4,"y":306.1,"t":0.385,"rol":"paso","casa":false},{"n":"Baiona","x":137.8,"y":277.5,"t":0.538,"rol":"paso","casa":false},{"n":"Vigo","x":150.7,"y":261.6,"t":0.615,"rol":"paso","casa":true},{"n":"Redondela","x":161.7,"y":256.0,"t":0.692,"rol":"paso","casa":true},{"n":"Pontevedra","x":158.2,"y":236.6,"t":0.769,"rol":"paso","casa":true},{"n":"Caldas de Reis","x":158.4,"y":213.7,"t":0.846,"rol":"paso","casa":true},{"n":"Padrón","x":156.6,"y":196.0,"t":0.923,"rol":"paso","casa":true},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false}],"m":[{"n":"Porto","x":159.7,"y":404.1,"t":0.0,"rol":"inicio","casa":false,"i":0},{"n":"A Guarda","x":135.4,"y":306.1,"t":0.385,"rol":"paso","casa":false,"i":4},{"n":"Pontevedra","x":158.2,"y":236.6,"t":0.769,"rol":"paso","casa":true,"i":8},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false,"i":11}],"lista":["Porto","Vila do Conde","Viana do Castelo","Caminha","A Guarda","Baiona","Vigo","Redondela","Pontevedra","Caldas de Reis","Padrón","Santiago"],"bb":[135.4,177.4,168.1,404.1]},"norte":{"d":"M836.1 117.3C832.9 117.7,823.4 118.7,817.1 119.9C810.8 121.1,804.4 123.9,798.3 124.4C792.2 124.9,785.7 122.4,780.4 122.7C775.1 123.0,771.8 126.8,766.4 126.4C761.0 126.0,755.4 120.0,748.1 120.1C740.8 120.2,728.4 127.3,722.8 127.2C717.2 127.1,719.0 122.2,714.4 119.6C709.8 117.0,701.3 113.4,694.9 111.4C688.5 109.4,679.7 108.8,675.7 107.5C671.7 106.2,675.2 104.8,671.0 103.6C666.8 102.4,656.2 100.8,650.4 100.4C644.6 100.0,643.6 99.4,636.3 101.0C629.0 102.6,614.7 108.5,606.8 110.2C598.9 111.9,593.6 110.8,588.8 110.9C584.0 111.0,585.8 111.3,578.1 110.6C570.4 109.8,553.7 108.0,542.8 106.4C531.9 104.8,524.1 102.4,512.9 101.0C501.7 99.6,485.3 99.7,475.4 98.2C465.4 96.7,461.3 93.4,453.2 91.8C445.1 90.2,436.5 89.2,427.1 88.7C417.7 88.2,404.4 88.8,396.7 88.9C389.0 89.0,386.1 89.0,381.1 89.3C376.1 89.6,372.1 90.5,366.7 90.7C361.3 90.9,356.7 90.6,348.4 90.7C340.1 90.8,326.3 89.8,316.9 91.3C307.5 92.8,297.2 97.5,291.9 99.9C286.6 102.3,288.1 103.3,285.0 105.5C281.9 107.8,278.3 110.5,273.0 113.4C267.8 116.3,257.8 119.1,253.5 122.7C249.2 126.3,253.1 129.7,247.4 135.2C241.7 140.7,226.4 149.7,219.5 155.7C212.6 161.7,211.6 168.0,206.0 171.0C200.4 174.0,192.2 172.7,185.9 173.8C179.6 174.9,171.1 176.8,168.1 177.4","g":[{"n":"Irún","x":836.1,"y":117.3,"t":0},{"n":"Bilbao","x":722.8,"y":127.2,"t":0.176},{"n":"Santander","x":636.3,"y":101,"t":0.353},{"n":"Gijón","x":453.2,"y":91.8,"t":0.559},{"n":"Ribadeo","x":316.9,"y":91.3,"t":0.735},{"n":"Mondoñedo","x":285,"y":105.5,"t":0.794},{"n":"Arzúa","x":206,"y":171,"t":0.941},{"n":"Santiago","x":168.1,"y":177.4,"t":1}],"m":[{"n":"Irún","x":836.1,"y":117.3,"t":0,"i":0},{"n":"Santander","x":636.3,"y":101,"t":0.353,"i":2},{"n":"Mondoñedo","x":285,"y":105.5,"t":0.794,"i":5},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":7}],"lista":["Irún","Bilbao","Santander","Gijón","Ribadeo","Mondoñedo","Arzúa","Santiago"],"bb":[168.1,88.7,836.1,177.4]},"ingles":{"d":"M198.5 98.3C199.9 98.0,205.7 94.8,206.9 96.6C208.1 98.4,206.5 104.2,205.5 108.9C204.5 113.6,203.5 119.9,200.8 124.9C198.1 129.9,193.6 132.9,189.3 139.1C185.0 145.3,178.6 155.4,175.1 161.8C171.6 168.2,169.3 174.8,168.1 177.4","g":[{"n":"Ferrol","x":198.5,"y":98.3,"t":0},{"n":"Pontedeume","x":205.5,"y":108.9,"t":0.333},{"n":"Betanzos","x":200.8,"y":124.9,"t":0.5},{"n":"Bruma","x":189.3,"y":139.1,"t":0.667},{"n":"Sigüeiro","x":175.1,"y":161.8,"t":0.833},{"n":"Santiago","x":168.1,"y":177.4,"t":1}],"m":[{"n":"Ferrol","x":198.5,"y":98.3,"t":0,"i":0},{"n":"Betanzos","x":200.8,"y":124.9,"t":0.5,"i":2},{"n":"Bruma","x":189.3,"y":139.1,"t":0.667,"i":3},{"n":"Santiago","x":168.1,"y":177.4,"t":1,"i":5}],"lista":["Ferrol","Pontedeume","Betanzos","Bruma","Sigüeiro","Santiago"],"bb":[168.1,96.6,206.9,177.4]},"primitivo":{"d":"M434.6 114.1C431.0 113.5,419.6 111.8,412.8 110.7C406.1 109.6,399.8 106.6,394.1 107.7C388.4 108.8,384.2 114.5,378.5 117.5C372.8 120.5,367.4 122.7,359.9 125.4C352.4 128.1,341.1 130.2,333.5 133.6C325.9 136.9,320.1 141.2,314.2 145.5C308.2 149.8,305.9 157.1,297.8 159.5C289.8 161.9,273.3 157.8,265.9 160.0C258.5 162.2,260.9 170.4,253.3 172.6C245.8 174.8,228.5 173.2,220.6 173.0C212.7 172.8,211.8 171.0,206.0 171.1C200.2 171.2,192.4 172.8,186.1 173.8C179.8 174.9,171.1 176.8,168.1 177.4","g":[{"n":"Oviedo","x":434.6,"y":114.1,"t":0.0,"rol":"inicio","casa":false},{"n":"Grado","x":412.8,"y":110.7,"t":0.077,"rol":"paso","casa":false},{"n":"Salas","x":394.1,"y":107.7,"t":0.154,"rol":"paso","casa":false},{"n":"Tineo","x":378.5,"y":117.5,"t":0.231,"rol":"paso","casa":false},{"n":"Pola de Allande","x":359.9,"y":125.4,"t":0.308,"rol":"paso","casa":false},{"n":"Grandas de Salime","x":333.5,"y":133.6,"t":0.385,"rol":"paso","casa":false},{"n":"A Fonsagrada","x":314.2,"y":145.5,"t":0.462,"rol":"paso","casa":false},{"n":"Lugo","x":265.9,"y":160.0,"t":0.615,"rol":"paso","casa":false},{"n":"Melide","x":220.6,"y":173.0,"t":0.769,"rol":"paso","casa":false},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false}],"m":[{"n":"Oviedo","x":434.6,"y":114.1,"t":0.0,"rol":"inicio","casa":false,"i":0},{"n":"Tineo","x":378.5,"y":117.5,"t":0.231,"rol":"paso","casa":false,"i":3},{"n":"A Fonsagrada","x":314.2,"y":145.5,"t":0.462,"rol":"paso","casa":false,"i":6},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false,"i":9}],"lista":["Oviedo","Grado","Salas","Tineo","Pola de Allande","Grandas de Salime","A Fonsagrada","Lugo","Melide","Santiago"],"bb":[168.1,107.7,434.6,177.4]},"invierno":{"d":"M361.2 221.4C358.2 223.3,350.0 230.0,343.4 232.9C336.8 235.8,327.3 237.5,321.7 238.9C316.1 240.3,314.3 242.9,309.7 241.5C305.1 240.1,298.6 233.8,294.0 230.3C289.4 226.8,285.8 221.3,281.9 220.3C277.9 219.3,276.5 225.6,270.3 224.5C264.1 223.4,251.8 216.4,244.6 213.5C237.3 210.6,232.4 208.5,226.8 207.3C221.2 206.1,215.7 207.3,210.8 206.4C206.0 205.5,203.2 204.6,197.7 201.9C192.1 199.2,182.4 194.3,177.5 190.2C172.6 186.1,169.7 179.5,168.1 177.4","g":[{"n":"Ponferrada","x":361.2,"y":221.4,"t":0.0,"rol":"inicio","casa":false},{"n":"Las Médulas","x":343.4,"y":232.9,"t":0.083,"rol":"paso","casa":false},{"n":"O Barco de Valdeorras","x":321.7,"y":238.9,"t":0.167,"rol":"paso","casa":false},{"n":"Quiroga","x":294.0,"y":230.3,"t":0.333,"rol":"paso","casa":false},{"n":"Monforte de Lemos","x":270.3,"y":224.5,"t":0.5,"rol":"paso","casa":false},{"n":"Chantada","x":244.6,"y":213.5,"t":0.583,"rol":"paso","casa":false},{"n":"Lalín","x":210.8,"y":206.4,"t":0.75,"rol":"paso","casa":false},{"n":"Silleda","x":197.7,"y":201.9,"t":0.833,"rol":"paso","casa":false},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false}],"m":[{"n":"Ponferrada","x":361.2,"y":221.4,"t":0.0,"rol":"inicio","casa":false,"i":0},{"n":"Quiroga","x":294.0,"y":230.3,"t":0.333,"rol":"paso","casa":false,"i":3},{"n":"Lalín","x":210.8,"y":206.4,"t":0.75,"rol":"paso","casa":false,"i":6},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false,"i":8}],"lista":["Ponferrada","Las Médulas","O Barco de Valdeorras","Quiroga","Monforte de Lemos","Chantada","Lalín","Silleda","Santiago"],"bb":[168.1,177.4,361.2,241.5]},"sanabres":{"d":"M446.1 319.6C442.3 319.1,426.3 320.8,423.4 316.6C420.5 312.4,434.9 298.3,428.8 294.4C422.7 290.5,398.8 294.7,386.8 293.3C374.9 291.9,365.6 286.7,357.1 286.0C348.6 285.3,344.1 289.0,335.7 288.9C327.3 288.8,316.9 285.7,306.8 285.1C296.7 284.5,284.6 288.3,274.9 285.3C265.1 282.3,254.9 273.0,248.3 267.0C241.7 261.0,239.2 254.9,235.4 249.1C231.6 243.2,228.5 237.0,225.2 231.9C221.9 226.8,220.0 223.7,215.4 218.7C210.8 213.7,204.0 206.7,197.7 201.9C191.4 197.2,182.4 194.3,177.5 190.2C172.6 186.1,169.7 179.5,168.1 177.4","g":[{"n":"Granja de Moreruela","x":446.1,"y":319.6,"t":0.0,"rol":"inicio","casa":false},{"n":"Tábara","x":423.4,"y":316.6,"t":0.071,"rol":"paso","casa":false},{"n":"Puebla de Sanabria","x":357.1,"y":286.0,"t":0.286,"rol":"paso","casa":false},{"n":"A Gudiña","x":306.8,"y":285.1,"t":0.429,"rol":"paso","casa":false},{"n":"Laza","x":274.9,"y":285.3,"t":0.5,"rol":"paso","casa":false},{"n":"Ourense","x":235.4,"y":249.1,"t":0.643,"rol":"paso","casa":false},{"n":"Cea","x":225.2,"y":231.9,"t":0.714,"rol":"paso","casa":false},{"n":"Silleda","x":197.7,"y":201.9,"t":0.857,"rol":"paso","casa":false},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false}],"m":[{"n":"Granja de Moreruela","x":446.1,"y":319.6,"t":0.0,"rol":"inicio","casa":false,"i":0},{"n":"A Gudiña","x":306.8,"y":285.1,"t":0.429,"rol":"paso","casa":false,"i":3},{"n":"Cea","x":225.2,"y":231.9,"t":0.714,"rol":"paso","casa":false,"i":6},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false,"i":8}],"lista":["Granja de Moreruela","Tábara","Puebla de Sanabria","A Gudiña","Laza","Ourense","Cea","Silleda","Santiago"],"bb":[168.1,177.4,446.1,319.6]},"plata":{"d":"M421.2 900.0C416.3 884.8,398.8 831.2,391.7 808.7C384.6 786.2,379.3 775.4,378.5 764.8C377.7 754.2,385.6 756.1,386.8 745.1C388.0 734.1,384.1 712.5,385.7 699.0C387.3 685.5,397.1 676.1,396.6 663.9C396.1 651.6,384.5 639.4,382.9 625.5C381.3 611.6,384.5 592.5,386.8 580.6C389.1 568.7,389.8 563.4,396.6 554.3C403.5 545.2,421.0 533.1,427.9 525.8C434.8 518.5,435.1 517.3,437.8 510.4C440.6 503.4,441.9 497.7,444.4 484.1C446.9 470.5,451.4 442.7,453.0 428.8C454.6 414.9,455.6 412.4,454.3 400.7C453.0 389.0,446.4 372.1,445.0 358.6C443.6 345.1,460.8 331.7,446.1 319.6C431.5 307.5,380.3 291.8,357.1 286.0C333.9 280.2,320.5 285.2,306.8 285.1C293.1 285.0,286.8 291.3,274.9 285.3C263.0 279.3,248.3 263.0,235.4 249.1C222.5 235.2,208.9 213.8,197.7 201.9C186.5 190.0,173.0 181.5,168.1 177.4","g":[{"n":"Sevilla","x":421.2,"y":900.0,"t":0.0,"rol":"inicio","casa":false},{"n":"Zafra","x":378.5,"y":764.8,"t":0.095,"rol":"paso","casa":false},{"n":"Mérida","x":385.7,"y":699.0,"t":0.19,"rol":"paso","casa":false},{"n":"Cáceres","x":382.9,"y":625.5,"t":0.286,"rol":"paso","casa":false},{"n":"Salamanca","x":453.0,"y":428.8,"t":0.571,"rol":"paso","casa":false},{"n":"Zamora","x":445.0,"y":358.6,"t":0.667,"rol":"paso","casa":false},{"n":"Granja de Moreruela","x":446.1,"y":319.6,"t":0.714,"rol":"paso","casa":false},{"n":"Puebla de Sanabria","x":357.1,"y":286.0,"t":0.762,"rol":"paso","casa":false},{"n":"Ourense","x":235.4,"y":249.1,"t":0.905,"rol":"paso","casa":false},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false}],"m":[{"n":"Sevilla","x":421.2,"y":900.0,"t":0.0,"rol":"inicio","casa":false,"i":0},{"n":"Cáceres","x":382.9,"y":625.5,"t":0.286,"rol":"paso","casa":false,"i":3},{"n":"Granja de Moreruela","x":446.1,"y":319.6,"t":0.714,"rol":"paso","casa":false,"i":6},{"n":"Santiago","x":168.1,"y":177.4,"t":1.0,"rol":"final","casa":false,"i":9}],"lista":["Sevilla","Zafra","Mérida","Cáceres","Salamanca","Zamora","Granja de Moreruela","Puebla de Sanabria","Ourense","Santiago"],"bb":[168.1,177.4,454.3,900.0]},"fisterra":{"d": "M168.1 177.4C164.8 176.8,156.7 175.1,148.6 174.0C140.5 172.9,125.5 171.8,119.6 170.9C113.7 170.0,114.5 170.2,113.2 168.7C111.9 167.2,113.5 165.1,111.5 161.7C109.5 158.2,103.3 147.7,101.5 148.0C99.7 148.3,101.5 159.2,100.7 163.5C100.0 167.8,97.6 172.3,97.0 174.1", "g": [{"n": "Santiago", "x": 168.1, "y": 177.4, "t": 0.0, "rol": "inicio", "casa": false, "i": 0}, {"n": "Negreira", "x": 148.6, "y": 174.0, "t": 0.143, "rol": "paso", "casa": false, "i": 1}, {"n": "Olveiroa", "x": 119.6, "y": 170.9, "t": 0.286, "rol": "paso", "casa": false, "i": 2}, {"n": "Muxía", "x": 101.5, "y": 148.0, "t": 0.714, "rol": "paso", "casa": false, "i": 3}, {"n": "Fisterra", "x": 97.0, "y": 174.1, "t": 1.0, "rol": "final", "casa": false, "i": 4}], "m": [{"n": "Santiago", "x": 168.1, "y": 177.4, "t": 0.0, "rol": "inicio", "casa": false, "i": 0}, {"n": "Negreira", "x": 148.6, "y": 174.0, "t": 0.143, "rol": "paso", "casa": false, "i": 1}, {"n": "Muxía", "x": 101.5, "y": 148.0, "t": 0.714, "rol": "paso", "casa": false, "i": 3}, {"n": "Fisterra", "x": 97.0, "y": 174.1, "t": 1.0, "rol": "final", "casa": false, "i": 4}], "lista": ["Santiago", "Negreira", "Olveiroa", "Hospital", "Dumbría", "Muxía", "Lires", "Fisterra"], "bb": [97.0, 148.0, 168.1, 177.4]}}};
  var chips = $('#chips'), rt = $('#rt'), rtBg = $('#rtBg'), nodes = $('#rNodes');
  var otras = $('#mOtras'), lista = $('#rLista'), ultima = null;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var mapa = $('#rMap'), ASP = GEO.meta.W / GEO.meta.H;
  var esc = $('.mesc'), bru = $('.mbru'), escLinea = esc.querySelector('path'), escTxt = esc.querySelector('text');
  var sant = $('.msant'), tramaP = $('#mDots'), tramaC = tramaP.querySelector('circle');
  var vbActual = [0,0,GEO.meta.W,GEO.meta.H], vbAnim = null, uPx = 1;

  /* El encuadre se acerca a la ruta elegida. A la misma escala para todas, el
     Camino Inglés (122 km) quedaba en cuatro píxeles con los nombres pisados.
     La barra de escala se recalcula, así que sigue siendo honesto. */
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden && destinoVb) verVb(destinoVb);
  });
  function encuadre(bb){
    var cx = (bb[0]+bb[2])/2, cy = (bb[1]+bb[3])/2;
    var w = Math.max(bb[2]-bb[0], 150) * 1.55, h = Math.max(bb[3]-bb[1], 120) * 1.35;
    /* La forma de la tarjeta se adapta a la ruta, entre estos dos límites. Con
       una proporción fija, el Norte (668 x 89) dejaba media tarjeta vacía y el
       Portugués salía como una tira. La altura se mueve sola al cambiar. */
    var a = w/h;
    if(a > 2.2) h = w/2.2; else if(a < 0.85) w = h*0.85;
    return [cx-w/2, cy-h/2, w, h];
  }
  function verVb(vb){
    mapa.setAttribute('viewBox', vb.map(function(n){ return n.toFixed(1); }).join(' '));
    var k = vb[2]/GEO.meta.W;
    mapa.style.setProperty('--k', k);
    // barra de escala: se elige una distancia redonda que ocupe ~un cuarto del ancho
    var kmVisibles = vb[2]*GEO.meta.kmU, elegido = 500;
    [500,200,100,50,20,10,5].forEach(function(v){ if(v <= kmVisibles*0.34) { elegido = Math.min(elegido, v); } });
    [5,10,20,50,100,200,500].forEach(function(v){ if(v <= kmVisibles*0.34) elegido = v; });
    var largo = elegido/GEO.meta.kmU;
    var u = uPx, t7 = 6*u, t14 = 12*u;
    escLinea.setAttribute('d','M0 0h'+largo.toFixed(1)+'M0 -'+t7.toFixed(1)+'v'+t14.toFixed(1)+'M'+largo.toFixed(1)+' -'+t7.toFixed(1)+'v'+t14.toFixed(1));
    escTxt.setAttribute('x',(largo/2).toFixed(1)); escTxt.setAttribute('y',(-9*u).toFixed(1));
    escTxt.textContent = elegido+' km';
    esc.setAttribute('transform','translate('+(vb[0]+vb[2]*0.05).toFixed(1)+','+(vb[1]+vb[3]*0.93).toFixed(1)+')');
    bru.setAttribute('transform','translate('+(vb[0]+vb[2]*0.94).toFixed(1)+','+(vb[1]+vb[3]*0.84).toFixed(1)+') scale('+u.toFixed(4)+')');
    /* El halo de Santiago y la retícula se mantienen del mismo tamaño en
       pantalla: si no, al acercarse al Inglés el halo era una mancha enorme y
       los puntos de la retícula quedaban a 80 px unos de otros. */
    sant.setAttribute('r', (34*uPx).toFixed(1));
    tramaP.setAttribute('width', (26*uPx).toFixed(2));
    tramaP.setAttribute('height', (26*uPx).toFixed(2));
    tramaC.setAttribute('cx', (1.4*uPx).toFixed(2));
    tramaC.setAttribute('cy', (1.4*uPx).toFixed(2));
    tramaC.setAttribute('r', (1.4*uPx).toFixed(2));
    vbActual = vb;
  }
  var destinoVb = null;
  function irA(vb){
    destinoVb = vb;
    /* En una pestaña de fondo requestAnimationFrame no corre: la animación se
       quedaba en el primer fotograma y el mapa aparecía sin acercar, con los
       nombres calculados para el encuadre de destino. Si no se ve, se salta. */
    if(REDUCE || document.hidden){ verVb(vb); return; }
    var de = vbActual.slice(), t0 = performance.now(), dur = 780;
    if(vbAnim) cancelAnimationFrame(vbAnim);
    (function paso(now){
      var q = Math.min(1,(now-t0)/dur), e = q<.5 ? 4*q*q*q : 1-Math.pow(-2*q+2,3)/2;
      verVb([0,1,2,3].map(function(i){ return de[i] + (vb[i]-de[i])*e; }));
      if(q<1) vbAnim = requestAnimationFrame(paso);
    })(t0);
  }
  var nName = $('#rName'), nFrom = $('#rFrom'), nWhen = $('#rWhen');
  if(!chips) return;

  function contar(el, fin){
    var ini = parseInt(el.textContent.replace(/\D/g,''),10) || 0;
    if(REDUCE){ el.textContent = fin.toLocaleString(WM_EN ? 'en-GB' : 'es-ES'); return; }
    var t0 = performance.now(), dur = 900;
    (function paso(now){
      var k = Math.min(1,(now-t0)/dur), e = 1 - Math.pow(1-k,3);
      el.textContent = Math.round(ini + (fin-ini)*e).toLocaleString(WM_EN ? 'en-GB' : 'es-ES');
      if(k<1) requestAnimationFrame(paso);
    })(t0);
  }
  function pintar(r){
    nName.textContent = r.nombre; nFrom.textContent = r.desde; nWhen.textContent = r.cuando;
    var g = GEO.rutas[r.id];
    if(!g) return;                                  // ruta sin geometría: no rompe nada

    // los otros nueve Caminos, de fondo
    otras.textContent = '';
    Object.keys(GEO.rutas).forEach(function(k){
      if(k === r.id) return;
      var pth = document.createElementNS(SVGNS,'path');
      pth.setAttribute('class','mghost'); pth.setAttribute('d', GEO.rutas[k].d);
      otras.appendChild(pth);
    });

    /* Si la línea todavía está a medio dibujar (la animación de la primera
       vez que entra en pantalla dura casi un segundo, y el editor de temas
       de Shopify la puede interrumpir otra vez al cambiar a vista móvil),
       un cambio de ruta en ese momento dejaba el trazo a medias. No basta
       con poner la transición a 0s y "añadir" la clase: si la clase ya
       estaba puesta (la línea a medio animar hacia el final), añadirla de
       nuevo no hace nada y la animación a medias se queda congelada ahí.
       Por eso se QUITA y se vuelve a PONER siempre, cada vez forzando un
       salto instantáneo (a "sin dibujar" y luego a "dibujada del todo"),
       así no importa en qué punto de cualquier animación estuviera antes. */
    rt.style.transitionDuration = '0s';
    rt.classList.remove('on');
    void rt.getBoundingClientRect();
    rtBg.setAttribute('d', g.d); rt.setAttribute('d', g.d);
    rt.classList.add('on');
    void rt.getBoundingClientRect();
    rt.style.transitionDuration = '';
    var vb = encuadre(g.bb);
    /* Los nombres y los puntos se calculan para verse SIEMPRE del mismo tamaño
       en pantalla (13 px), sea el mapa grande o pequeño y esté cerca o lejos.
       Antes se escalaban con el zoom y en el móvil salían de 4 px. */
    var anchoReal = mapa.getBoundingClientRect().width || 620;
    /* La altura se calcula aquí y se fija en el elemento. Leerla del CSS con
       getComputedStyle no vale: con max-height:min(58vh,520px) el navegador
       devuelve la fórmula sin resolver y los nombres salían gigantes. */
    var tope = Math.min(innerHeight * (anchoReal < 470 ? 0.64 : 0.58), anchoReal < 470 ? 460 : 520);
    var altoReal = Math.min(tope, anchoReal * vb[3] / vb[2]);
    mapa.style.height = Math.round(altoReal) + 'px';
    var ratio = Math.min(anchoReal / vb[2], altoReal / vb[3]);
    var kTxt = 13 / ratio, kPto = 6 / ratio;
    uPx = 1 / ratio;                 // unidades del dibujo por píxel de pantalla
    mapa.style.setProperty('--u', uPx.toFixed(4));
    irA(vb);
    var movil = anchoReal < 470;   // no cabe todo: cuatro nombres en vez de ocho
    var conNombre = {};
    (movil ? g.m : g.g).forEach(function(h){ conNombre[h.n] = h; });
    /* La lista de abajo son los pueblos DE VERDAD (el final de cada etapa,
       segun Gronze), no los puntos que caben en el mapa. Gustavo, 16/08:
       «si no sabes cuantos pueblos son, no pongas un numero exacto, porque
       al final estas confirmando; y si sabes, enumeralos». El mapa sigue
       con sus seis u ocho nombres, que es lo que cabe sin volverse una
       mancha; la respuesta completa vive aqui, en texto. */
    lista.textContent = (r.pueblos || g.lista).join(' · ');

    /* El pie del mapa decía SIEMPRE «fíjate en que todos acaban en el mismo
       punto». En el de Fisterra e Muxía eso es MENTIRA, y encima es el único
       Camino cuya gracia es justo la contraria: sale de Santiago. Peor aún:
       el resplandor fijo de Santiago (.msant) hace que parezca el final.
       Así que en ese Camino el pie dice lo que de verdad se está viendo.
       (17/09/2026, mirando la vista previa.) */
    var leyenda = $('.pick__leyenda');
    if (leyenda) {
      leyenda.textContent = r.id === 'fisterra'
        ? T('Mapa real: cada Camino en su sitio. El tuyo en oro, los otros nueve de fondo. Este es el único que no acaba en Santiago: empieza ahí, y sigue hasta el final de la tierra.',
            'A real map: every Camino in its place. Yours in gold, the other nine in the background. This is the only one that doesn\'t end in Santiago: it starts there and goes on to the end of the earth.')
        : T('Mapa real: cada Camino en su sitio. El tuyo en oro, los otros nueve de fondo. Fíjate en que todos acaban en el mismo punto.',
            'A real map: every Camino in its place. Yours in gold, the other nine in the background. Notice how they all end at the same point.');
    }

    // En un móvil no caben ocho nombres legibles: se enseñan cuatro con la letra
    // grande y la lista completa va debajo en texto.

    /* ---------------------------------------------------------------------
       DÓNDE VA CADA NOMBRE  (17/09/2026)
       ---------------------------------------------------------------------
       Antes la posición del rótulo venía calculada de casa, en `tx`/`ty` del
       GEO, y aquí solo se escalaba:  x = h.x + (e.tx-h.x)*kSep.

       Eso estaba MAL y se veía. `kSep` vale 1/ratio, o sea unidades de dibujo
       por píxel de pantalla, y cambia con el zoom de cada Camino: 0,48 en el
       Sanabrés y 1,88 en la Vía de la Plata. Así que una separación pensada
       para 40 unidades salía de 76 en la Plata — y el nombre aterrizaba
       CUATRO VECES más lejos de su punto que en otro mapa.

       Consecuencias reales que vio Gustavo el 17/09:
         · Vía de la Plata: «Ourense» se iba 76 unidades a la IZQUIERDA y
           «Santiago» 76 a la DERECHA. Se cruzaban: el rótulo «Ourense»
           acababa pegado al punto gordo de Santiago y parecía que el Camino
           MÁS LARGO DE TODOS terminaba en Ourense.
         · Sanabrés: «Granja de Moreruela» se montaba encima de Tábara y
           parecía que el Camino empezaba en Tábara.

       Ahora la colocación se decide AQUÍ, al dibujar, en píxeles de pantalla
       de verdad, mirando dónde ha quedado todo lo demás. Se prueban ocho
       posiciones alrededor del punto y se coge la primera que no pise nada.
       Los extremos van PRIMEROS, para que el primer pueblo y Santiago se
       queden siempre con el mejor sitio: son los dos que contestan «¿de
       dónde a dónde va esto?». */
    var margenPx = 9;                 // separación entre el punto y su nombre
    var anchoChar = kTxt * 0.52;      // ancho medio por letra a 13 px, en unidades
    var altoTxt = kTxt * 0.72;
    var radioPto = kPto * 1.25 + kTxt * 0.25;
    var sep = margenPx * uPx;         // el margen, pasado a unidades de dibujo
    var puestos = [];                 // cajas ya ocupadas por otros nombres

    function caja(h, dx, dy, anc, ancho) {
      var x = h.x + dx, y = h.y + dy;
      var izq = ancho === 'end' ? x - anc : (ancho === 'middle' ? x - anc / 2 : x);
      return { x1: izq, y1: y - altoTxt, x2: izq + anc, y2: y + altoTxt * 0.35 };
    }
    function pisa(a, b) {
      var p = kTxt * 0.18;
      return !(a.x2 + p < b.x1 || b.x2 + p < a.x1 || a.y2 + p < b.y1 || b.y2 + p < a.y1);
    }
    /* Cuánto se sale del mapa. No es descalificatorio por sí solo —en el
       Inglés casi todo roza el borde—, pero entre dos sitios igual de buenos
       gana el que se sale menos. */
    function fuera(c) {
      return Math.max(0, vb[0] - c.x1) + Math.max(0, c.x2 - (vb[0] + vb[2]))
           + Math.max(0, vb[1] - c.y1) + Math.max(0, c.y2 - (vb[1] + vb[3]));
    }

    var candidatos = [
      [ 1,  0.30, 'start' ],   // a la derecha, que es lo que mejor se lee
      [-1,  0.30, 'end'   ],   // a la izquierda
      [ 0, -1.00, 'middle'],   // encima
      [ 0,  1.30, 'middle'],   // debajo
      [ 1, -0.85, 'start' ],   // las cuatro diagonales, por si el punto está
      [-1, -0.85, 'end'   ],   // en un recodo y los cuatro lados de arriba
      [ 1,  1.15, 'start' ],   // están ocupados
      [-1,  1.15, 'end'   ],
    ];

    /* La propia línea del Camino también estorba: al mirarlo el 17/09, en el
       Primitivo cinco nombres quedaban sentados encima del trazo. Se leen
       igual (el texto lleva un halo oscuro detrás), pero ensucia. Se sacan
       ~70 puntos de la línea de verdad —con getPointAtLength, no adivinando—
       y pisar el trazo penaliza; menos que pisar otro nombre, porque entre
       taparle el nombre a un pueblo y cruzar la línea, cruzar la línea es lo
       de menos. */
    var puntosLinea = [];
    try {
      var largoTotal = rt.getTotalLength();
      if (largoTotal > 0) {
        for (var s = 0; s <= 70; s++) {
          var pt = rt.getPointAtLength(largoTotal * s / 70);
          puntosLinea.push(pt);
        }
      }
    } catch (err) { /* navegador sin getPointAtLength: se sigue sin esto */ }

    var conNodo = [];
    g.g.forEach(function(h, i) { conNodo.push({ h: h, i: i, fin: i === g.g.length - 1 }); });
    // Primero los dos extremos; después el resto, en orden.
    var orden = conNodo.filter(function(n) { return n.i === 0 || n.fin; })
      .concat(conNodo.filter(function(n) { return n.i !== 0 && !n.fin; }));

    var colocado = {};
    orden.forEach(function(n) {
      var h = n.h;
      if (!conNombre[h.n]) return;
      var anc = h.n.length * anchoChar;
      var mejor = null, mejorMal = Infinity;
      for (var c = 0; c < candidatos.length; c++) {
        var dx = candidatos[c][0] * (sep + (candidatos[c][2] === 'middle' ? 0 : radioPto));
        var dy = candidatos[c][1] * (sep + radioPto);
        var cj = caja(h, dx, dy, anc, candidatos[c][2]);
        var mal = fuera(cj) * 0.4;
        for (var p = 0; p < puestos.length; p++) if (pisa(cj, puestos[p])) mal += 1000;
        // Que un nombre no se siente encima del punto de OTRO pueblo.
        for (var q = 0; q < g.g.length; q++) {
          var o = g.g[q];
          if (o === h) continue;
          if (o.x > cj.x1 - radioPto && o.x < cj.x2 + radioPto &&
              o.y > cj.y1 - radioPto && o.y < cj.y2 + radioPto) mal += 600;
        }
        // Y que no se siente encima del trazo, si hay dónde elegir.
        for (var L = 0; L < puntosLinea.length; L++) {
          var pl = puntosLinea[L];
          if (pl.x > cj.x1 && pl.x < cj.x2 && pl.y > cj.y1 && pl.y < cj.y2) { mal += 120; break; }
        }
        if (mal < mejorMal) { mejorMal = mal; mejor = { dx: dx, dy: dy, a: candidatos[c][2], cj: cj }; }
        if (mal === 0) break;   // perfecto, no hace falta seguir probando
      }
      puestos.push(mejor.cj);
      colocado[h.n] = mejor;
    });

    nodes.textContent = '';
    g.g.forEach(function(h,i){
      var fin = i === g.g.length - 1;
      /* PUNTOS HUÉRFANOS EN EL MÓVIL (17/09/2026, lo vio Gustavo en su móvil).
         ---------------------------------------------------------------------
         En el móvil no caben ocho nombres, así que se enseñan cuatro (`g.m`).
         Pero los CÍRCULOS se dibujaban todos igual, los catorce. En el Camino
         Portugués, que tiene cinco paradas apretadas entre Redondela y
         Santiago, eso daba «siete puntos y dos nombres»: bolitas sin decir
         qué son, que además tapaban el trazo.

         Gustavo: «borra algunos puntos y deja la línea fina por debajo, como
         es el camino». Tiene razón y es la regla correcta: **un punto sin
         nombre no informa de nada, solo ensucia**. Donde no hay rótulo, el
         Camino se ve como lo que es: una línea.

         En escritorio no cambia nada — allí `g.g` son todos y todos llevan
         nombre, así que no hay ninguno huérfano que quitar. */
      var e = colocado[h.n];
      if (!e && !fin && i !== 0) {
        // Sin rótulo y no es un extremo: solo línea. El principio y el final
        // se dibujan SIEMPRE, lleven nombre o no: son los que contestan
        // «¿de dónde a dónde va esto?».
        return;
      }
      var nodo = document.createElementNS(SVGNS,'g');
      nodo.setAttribute('class','nd' + (fin ? ' nd--end' : '') + (i === 0 ? ' nd--ini' : ''));
      var c = document.createElementNS(SVGNS,'circle');
      c.setAttribute('cx',h.x); c.setAttribute('cy',h.y); c.setAttribute('r', (kPto*(fin?1.25:1)).toFixed(2));
      nodo.appendChild(c);
      if(e){
        var tx = document.createElementNS(SVGNS,'text');
        tx.setAttribute('x', (h.x + e.dx).toFixed(1));
        tx.setAttribute('y', (h.y + e.dy).toFixed(1));
        tx.setAttribute('text-anchor', e.a);
        /* En estilo, no en atributo: la hoja de estilos (.nd text{font:600 13px})
           gana a los atributos de presentación del SVG y los nombres salían a
           13 unidades del dibujo, o sea 40 px en pantalla. */
        tx.style.fontSize = kTxt.toFixed(2) + 'px';
        tx.style.strokeWidth = (kTxt*0.27).toFixed(2) + 'px';
        tx.textContent = h.n;
        nodo.appendChild(tx);
      }
      nodes.appendChild(nodo);
      nodo.classList.add('on');
    });

    contar($('[data-num=km]'), r.km);
    contar($('[data-num=dias]'), r.dias);
    /* Antes: r.hitos.length, o sea el numero de PUNTOS DEL MAPA. Salia
       "8 pueblos" en el Frances, en el Portugues, en el Norte y en la
       Costa, porque los cuatro tienen ocho puntos. Nadie hace el Frances
       pasando por ocho pueblos. Ahora es el numero de etapas publicado. */
    contar($('[data-num=etapas]'), r.etapas);
    ultima = r;
  }
  // Al girar el móvil o cambiar de tamaño cambia el juego de etiquetas.
  var tRedibuja = null;
  addEventListener('resize', function(){
    clearTimeout(tRedibuja);
    tRedibuja = setTimeout(function(){ if(ultima) pintar(ultima); }, 220);
  });
  var interactuado = false;
  RUTAS.forEach(function(r,i){
    var b = document.createElement('button');
    b.type='button'; b.className='chip'; b.textContent=r.corto; b.setAttribute('aria-pressed', String(i===0));
    b.addEventListener('click', function(){
      interactuado = true;
      $$('.chip',chips).forEach(function(o){ o.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true'); pintar(r);
    });
    chips.appendChild(b);
  });
  // Se pinta ya, sin esperar a nada. Antes esperaba a que la sección entrase en
  // pantalla y, si el observador no disparaba (pestaña en segundo plano), el
  // mapa se quedaba vacío. El dibujo de la línea sí se reanima al entrar.
  pintar(RUTAS[0]);
  var visto = false;
  new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting && !visto){
        visto = true;
        // Si el usuario ya tocó un chip antes de que esto se dispare (el observador
        // es async y puede llegar tarde respecto a un toque casi simultáneo), no se
        // toca nada: pintar() ya dejó la línea actual bien dibujada y reiniciar aquí
        // la animación de entrada la dejaría a medias otra vez.
        if(interactuado) return;
        rt.classList.remove('on');
        requestAnimationFrame(function(){ rt.classList.add('on'); });
      }
    });
  }, {threshold:.25}).observe($('#tu-camino'));
})();

/* ---------- EL VÍDEO-RECUERDO QUE SE MONTA ---------- */
(function(){
  var box = $('#player'); if(!box) return;
  var drawn = $('#fDrawn'), dot = $('#fDot'), bar = $('#fBar'), end = $('#fEnd'), btn = $('#fPlay');
  var piezas = $$('.fph,.fnote,.flbl', box);
  var largo = drawn.getTotalLength();
  var t0 = null, jugando = false, dur = 7200, p = 0, hecho = false;

  function pintar(q){
    p = q;
    drawn.style.strokeDashoffset = String(1 - q);
    var pt = drawn.getPointAtLength(largo * q);
    dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y);
    bar.style.width = (q*100) + '%';
    piezas.forEach(function(el){ el.classList.toggle('on', q >= parseFloat(el.dataset.at)); });
    var fin = q > .93;
    end.classList.toggle('on', fin);
    if(fin && !hecho){ hecho = true; numeros(); }
    if(!fin) hecho = false;
  }
  function numeros(){
    $$('[data-fnum]', end).forEach(function(el){
      var f = +el.dataset.fnum;
      if(REDUCE){ el.textContent = f; return; }
      var s = performance.now();
      (function paso(now){
        var k = Math.min(1,(now-s)/1100), e = 1 - Math.pow(1-k,3);
        el.textContent = Math.round(f*e);
        if(k<1) requestAnimationFrame(paso);
      })(s);
    });
  }
  function tic(now){
    if(!jugando) return;
    if(t0 === null) t0 = now - p*dur;
    var q = Math.min(1, (now - t0)/dur);
    pintar(q);
    if(q < 1) requestAnimationFrame(tic);
    else { jugando = false; t0 = null; etiqueta(false); }
  }
  function etiqueta(activo){
    btn.querySelector('span').textContent = activo ? T('Pausa','Pause') : (p >= 1 ? T('Verlo otra vez','Watch it again') : T('Ver cómo se monta','Watch it come together'));
    btn.querySelector('path').setAttribute('d', activo ? 'M7 5h4v14H7zM13 5h4v14h-4z' : 'M8 5v14l11-7z');
  }
  function play(){
    if(p >= 1){ p = 0; pintar(0); }
    jugando = true; t0 = null; etiqueta(true); requestAnimationFrame(tic);
  }
  function pausa(){ jugando = false; t0 = null; etiqueta(false); }
  btn.addEventListener('click', function(){ jugando ? pausa() : play(); });

  if(REDUCE){ pintar(1); etiqueta(false); }
  else {
    pintar(0);
    var arrancado = false;
    new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting && !arrancado){ arrancado = true; setTimeout(play, 400); }
        else if(!e.isIntersecting && jugando){ pausa(); }
      });
    }, {threshold:.45}).observe(box);
  }
})();

/* ---------- demo del móvil ---------- */
(function(){
  var demo = $('[data-demo]'); if(!demo) return;
  var scrs = $$('[data-scr]', demo), pasos = $$('[data-steps] li', demo);
  var dots = $('[data-dots]', demo), replay = $('[data-replay]', demo), typed = $('[data-typed]', demo);
  var NOTA = T('Los últimos 100 km. Hoy caminé con Anke, de Bremen. Nos perdimos dos veces y nos reímos las dos.','The last 100 km. Today I walked with Anke, from Bremen. We got lost twice and laughed both times.');
  var aPaso = [0,0,1,1,2], ESPERA = [1900,3000,2600,3800,3400];
  var etiquetas = WM_EN ? ['Ready','Your journal','Take the photo','Write the note','Saved'] : ['En reposo','Tu diario','Hacer la foto','Escribir la nota','Guardado'];
  var cur = 0, auto = !REDUCE, timer = null, typeT = null, dentro = false;
  var botones = etiquetas.map(function(txt,i){
    var b = document.createElement('button');
    b.type='button'; b.setAttribute('role','tab'); b.setAttribute('aria-label',txt);
    b.addEventListener('click', function(){ auto=false; ir(i); });
    dots.appendChild(b); return b;
  });
  function limpiar(){ clearTimeout(timer); clearInterval(typeT); timer=typeT=null; }
  function escribir(){ var i=0; typed.textContent=''; typeT=setInterval(function(){ typed.textContent=NOTA.slice(0,++i); if(i>=NOTA.length) clearInterval(typeT); },26); }
  function ir(i){
    limpiar();
    cur = (i + scrs.length) % scrs.length;
    scrs.forEach(function(s,k){ s.classList.toggle('on', k===cur); });
    botones.forEach(function(b,k){ b.setAttribute('aria-current', String(k===cur)); });
    pasos.forEach(function(el,k){ el.classList.toggle('on', k===aPaso[cur]); });
    if(cur===3){ REDUCE ? typed.textContent=NOTA : escribir(); }
    if(auto && dentro) timer = setTimeout(function(){ ir(cur+1); }, ESPERA[cur]);
  }
  replay.addEventListener('click', function(){ auto=true; ir(0); });
  new IntersectionObserver(function(es){
    es.forEach(function(e){ dentro = e.isIntersecting; if(dentro && auto) ir(cur); else limpiar(); });
  }, {threshold:.3}).observe(demo);
  REDUCE ? (auto=false, ir(1)) : ir(0);
})();

/* ---------- perfil de emergencia ---------- */
(function(){
  var wrap = $('[data-switches]'); if(!wrap) return;
  var filas = $$('.idrow'), vacio = $('[data-empty]');
  var inputs = $$('input[type=checkbox]', wrap);
  function sync(){
    var v = 0;
    inputs.forEach(function(inp){
      var f = filas.filter(function(x){ return x.dataset.row === inp.dataset.field; })[0];
      if(!f) return;
      f.hidden = !inp.checked;
      if(inp.checked) v++;
    });
    vacio.hidden = v > 0;
  }
  inputs.forEach(function(i){ i.addEventListener('change', sync); });
  sync();
})();

/* ---------- galería ---------- */
(function(){
  var main = $('#galMain'), wrap = $('[data-thumbs]');
  if(!main || !wrap) return;
  var bs = $$('button', wrap);
  bs.forEach(function(b){
    b.addEventListener('click', function(){
      bs.forEach(function(t){
        var on = t === b;
        t.setAttribute('aria-current', String(on));
        t.style.borderColor = on ? 'var(--gold)' : 'var(--line)';
        t.style.boxShadow = on ? '0 0 0 1px var(--gold)' : 'none';
      });
      main.style.opacity = '0';
      setTimeout(function(){
        main.src = b.dataset.src;
        var im = b.querySelector('img'); if(im) main.alt = im.alt;
        main.style.opacity = '1';
      }, 170);
    });
  });
  main.style.transition = 'opacity .35s var(--ease)';
})();

/* ---------- barra de compra en móvil ---------- */
(function(){
  var b = $('#buybar'), hero = $('.hero'), f = $('#fundadores');
  if(!b || !hero) return;
  function chk(){
    var pasado = hero.getBoundingClientRect().bottom < 0;
    var enFund = f && f.getBoundingClientRect().top < innerHeight*.8 && f.getBoundingClientRect().bottom > innerHeight*.2;
    b.classList.toggle('on', pasado && !enFund);
  }
  addEventListener('scroll', chk, {passive:true}); chk();
})();

/* ---------- alta en la lista (demostración local) ---------- */
(function(){
  var f = $('#subForm'); if(!f) return;
  var i = $('#subEmail'), n = $('#subNote');
  f.addEventListener('submit', function(e){
    e.preventDefault();
    var ok = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(i.value.trim());
    n.style.color = ok ? 'var(--gold-b)' : '#E8A0A0';
    n.textContent = ok ? T('¡Hecho! Te acabamos de mandar un correo de bienvenida. Revisa también spam.','Done! We\'ve just sent you a welcome email. Check your spam folder too.')
                       : T('Revisa el correo: parece que falta algo.','Check your email address: something seems to be missing.');
    if(ok) f.reset();
  });
})();
})();
